export const env = {
    BASE_URL : '/hupoxnet',
    BACKEND : 'https://kaabil.net/hupoxnetbackend'
}

